import request from '@/config/axios'
import { asCapacityPage, type CapacityPageResult } from '@/api/capacity/page'

export interface CapacityMockCreateReq {
  city: string
  strategy: 'free_pool' | 'org_dispatch'
  orgId?: string
  fee: number
  bizType?: string
  pickTitle?: string
  pickAddr?: string
  pickLat?: number
  pickLng?: number
  dropTitle?: string
  dropAddr?: string
  dropLat?: number
  dropLng?: number
  etaMinutes?: number
  remark?: string
}

export interface CapacityWaybillCreateResp {
  waybillId?: string
  status: string
  rejectReason?: string
  code?: string
}

export interface CapacityWaybillItem {
  waybillId: string
  externalId: string
  bizType: string
  fee: number
  currency: string
  city: string
  strategy: string
  orgId?: string
  status: string
  pickTitle?: string
  pickAddr?: string
  dropTitle?: string
  dropAddr?: string
  remark?: string
  riderPhone?: string
  overflowed?: boolean
  completionPhotoUrls?: string[]
  grabbedAt?: string
  createdAt?: string
}

/** 平台联调造单（fee 外部主权） */
export const mockCreateWaybill = (data: CapacityMockCreateReq) => {
  return request.post<CapacityWaybillCreateResp>({ url: '/capacity/waybill/mock-create', data })
}

/** 最近运单列表（巡检，分页） */
export const getWaybillList = async (params?: {
  keyword?: string
  city?: string
  status?: string
  strategy?: string
  orgId?: string
  pageNo?: number
  pageSize?: number
}): Promise<CapacityPageResult<CapacityWaybillItem>> => {
  const raw = await request.get({ url: '/capacity/waybill/list', params })
  return asCapacityPage<CapacityWaybillItem>(raw, params?.pageNo, params?.pageSize)
}

export interface WaybillOpsActResult {
  success: boolean
  message?: string
}

/** L1：卡住待办（accepted 无骑手 ≥5 分钟），分页 */
export const getWaybillTodos = async (params?: {
  pageNo?: number
  pageSize?: number
}): Promise<CapacityPageResult<CapacityWaybillItem>> => {
  const raw = await request.get({ url: '/capacity/platform/waybill/todos', params })
  return asCapacityPage<CapacityWaybillItem>(raw, params?.pageNo, params?.pageSize)
}

/** L1：RETURN_POOL | CANCEL | FORCE_ASSIGN */
export const waybillOpsAct = (data: {
  action: 'RETURN_POOL' | 'CANCEL' | 'FORCE_ASSIGN'
  waybillId: string
  toPhone?: string
}) => {
  return request.post<WaybillOpsActResult>({ url: '/capacity/platform/waybill/act', data })
}
